__turbopack_context__.v({
  "Large": "Spacer-module-scss-module__jttuRG__Large",
  "Small": "Spacer-module-scss-module__jttuRG__Small",
  "Spacer": "Spacer-module-scss-module__jttuRG__Spacer",
  "XLarge": "Spacer-module-scss-module__jttuRG__XLarge",
  "XSmall": "Spacer-module-scss-module__jttuRG__XSmall",
});
